module.exports = __webpack_public_path__ + "img/40261035000522.89fc9a79.png";